import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveNav, openSettings, showToast } from '../store/uiSlice';

function BottomNav() {
  const dispatch = useDispatch();
  const activeNav = useSelector((state) => state.ui.activeNav);

  const handleNav = (page) => {
    if (page === 'profile') {
      dispatch(openSettings());
    } else {
      dispatch(setActiveNav(page));
      // ROADMAP: Weekly view — full week schedule with phleb assignments by day
      // ROADMAP: History view — completed day logs with photo audit trail, filterable by date
      if (page !== 'home') {
        dispatch(showToast(page === 'week' ? 'Weekly view — coming soon' : 'History — coming soon'));
      }
    }
  };

  return (
    <div className="bottom-nav">
      <div className={`nav-item ${activeNav === 'home' ? 'active' : ''}`} onClick={() => handleNav('home')}>
        <div className="nav-icon">
          <svg viewBox="0 0 24 24"><path d="M3 12L12 3l9 9"/><path d="M9 21V12h6v9"/><path d="M3 12v9h18V12"/></svg>
        </div>
        <div className="nav-label">Today</div>
      </div>
      <div className={`nav-item ${activeNav === 'week' ? 'active' : ''}`} onClick={() => handleNav('week')}>
        <div className="nav-icon">
          <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
        </div>
        <div className="nav-label">This Week</div>
      </div>
      <div className={`nav-item ${activeNav === 'history' ? 'active' : ''}`} onClick={() => handleNav('history')}>
        <div className="nav-icon">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>
        </div>
        <div className="nav-label">History</div>
      </div>
      <div className={`nav-item ${activeNav === 'profile' ? 'active' : ''}`} onClick={() => handleNav('profile')}>
        <div className="nav-icon">
          <svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        </div>
        <div className="nav-label">Profile</div>
      </div>
    </div>
  );
}

export default BottomNav;
